import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useScreen } from '../lib/useScreen';
import TiltCard from '../lib/TiltCard';
import heroImg from '../assets/quienes-somos.jpg';
import CASOS_ONSITE from '../data/casosOnsite';

const C = { turquesa:'#5dc1b9', mango:'#FDBE02', coral:'#eb636b', verde:'#1D9E75', logoGrad:'linear-gradient(135deg, #534AB7, #1D9E75)', triGrad:'linear-gradient(135deg, #5dc1b9, #FDBE02, #eb636b)' };
const font = "'DM Sans', sans-serif";
const serif = "'DM Serif Display', serif";
const glass = { background:'rgba(255,255,255,0.05)', backdropFilter:'blur(30px)', border:'1px solid rgba(255,255,255,0.1)', borderRadius:24 };

function useScrollReveal() {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current; if (!el) return;
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) { setInView(true); obs.disconnect(); } }, { threshold: 0.15 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);
  return [ref, inView];
}

const reveal = (inView) => ({
  opacity: inView ? 1 : 0,
  transform: inView ? 'translateY(0) scale(1)' : 'translateY(60px) scale(0.96)',
  transition: 'opacity 0.8s ease-out, transform 0.8s ease-out',
});

// Animated counter
function Counter({ end, duration = 2000, inView }) {
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!inView) return;
    let start = 0;
    const step = end / (duration / 16);
    const timer = setInterval(() => {
      start += step;
      if (start >= end) { setVal(end); clearInterval(timer); }
      else setVal(Math.floor(start));
    }, 16);
    return () => clearInterval(timer);
  }, [inView, end, duration]);
  return <span>{val.toLocaleString()}</span>;
}

export default function About() {
  const navigate = useNavigate();
  const { isMobile, isTablet } = useScreen();
  const [projects, setProjects] = useState([]);
  const [stats, setStats] = useState({ users: 0, projects: 0, sales: 0, countries: 1 });

  // Load real data
  useEffect(() => {
    fetch('/api/get-projects').then(r => r.json()).then(d => {
      if (d.projects) {
        setProjects(d.projects);
        setStats(s => ({ ...s, users: d.projects.length, projects: d.projects.length }));
      }
    }).catch(() => {});
  }, []);

  // Scroll reveals
  const [heroRef, heroIn] = useScrollReveal();
  const [whoRef, whoIn] = useScrollReveal();
  const [philRef, philIn] = useScrollReveal();
  const [projRef, projIn] = useScrollReveal();
  const [numRef, numIn] = useScrollReveal();
  const [whatRef, whatIn] = useScrollReveal();
  const [joinRef, joinIn] = useScrollReveal();

  const handleLogin = () => { navigate('/'); };

  return (
    <div style={{ background:'#0a0a0a', color:'#fff', fontFamily:font, minHeight:'100vh', overflow:'hidden' }}>
      <style>{`
        .td-iri { background: linear-gradient(90deg, #5dc1b9, #FDBE02, #eb636b, #534AB7, #1D9E75, #5dc1b9); background-size: 300% 300%; -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; animation: iri 4s ease infinite; }
        @keyframes iri { 0% { background-position: 0% 50%; } 50% { background-position: 100% 50%; } 100% { background-position: 0% 50%; } }
        @media (prefers-reduced-motion: reduce) { .td-iri { animation: none; } }
        .caso-card:hover { transform: scale(1.02); box-shadow: 0 30px 80px rgba(0,0,0,.6); }
        .caso-card:hover .caso-foto { transform: scale(1.07); }
        .caso-card:hover .btn-caso-hover { background: rgba(255,255,255,.16) !important; }
        @keyframes casoFadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes casoZoomIn { 0% { transform: scale(.08) translateY(80px); opacity: 0; } 45% { opacity: 1; } 100% { transform: scale(1) translateY(0); opacity: 1; } }
      `}</style>

      {/* HERO — Full-screen image (Mercury style) */}
      <section ref={heroRef} style={{
        position:'relative', width:'100%', height:isMobile?'100svh':'100vh',
        display:'flex', alignItems:'center', justifyContent:'center', overflow:'hidden',
      }}>
        {/* Background image */}
        <img src={heroImg} alt="" style={{
          position:'absolute', inset:0, width:'100%', height:'100%',
          objectFit:'cover', objectPosition:'center',
        }} />
        {/* Dark overlay — top legibility */}
        <div style={{
          position:'absolute', inset:0,
          background:'linear-gradient(to bottom, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.15) 40%, transparent 60%)',
        }} />
        {/* Bottom fade — blends into page bg */}
        <div style={{
          position:'absolute', bottom:0, left:0, right:0, height:'35%',
          background:'linear-gradient(180deg, transparent 0%, #0a0a0a 100%)',
          pointerEvents:'none',
        }} />

        {/* NAV — absolute on top */}
        <nav style={{
          position:'absolute', top:0, left:0, right:0, zIndex:10,
          maxWidth:1000, margin:'0 auto', padding:isMobile?'1rem':'1.2rem 1.5rem',
          display:'flex', alignItems:'center', justifyContent:'space-between',
        }}>
          <div onClick={() => navigate('/')} style={{ display:'flex', alignItems:'center', gap:10, cursor:'pointer' }}>
            <div style={{ width:38, height:38, borderRadius:'50%', background:C.logoGrad, display:'flex', alignItems:'center', justifyContent:'center' }}>
              <span style={{ color:'#fff', fontSize:12, fontWeight:500 }}>T&D</span>
            </div>
            <span style={{ fontSize:16, fontWeight:500 }}>Thinker & Doer</span>
          </div>
          <div style={{ display:'flex', gap:16, alignItems:'center' }}>
            <span onClick={() => navigate('/')} style={{ fontSize:14, color:'rgba(255,255,255,0.8)', cursor:'pointer', fontFamily:font }}>Inicio</span>
            <span onClick={() => navigate('/membresias')} style={{ fontSize:14, color:'rgba(255,255,255,0.8)', cursor:'pointer', fontFamily:font }}>Membresías</span>
            <button onClick={handleLogin} style={{ background:C.logoGrad, color:'#fff', border:'none', borderRadius:50, padding:'10px 28px', fontSize:14, fontWeight:500, cursor:'pointer', fontFamily:font }}>Entrar</button>
          </div>
        </nav>

        {/* Hero text — centered */}
        <div style={{
          position:'relative', zIndex:5, textAlign:'center',
          padding:isMobile?'0 1.5rem':'0 2rem',
          opacity: heroIn ? 1 : 0, transform: heroIn ? 'translateY(0)' : 'translateY(30px)',
          transition:'opacity 1s ease-out, transform 1s ease-out',
          textShadow:'0 2px 24px rgba(0,0,0,0.45)',
        }}>
          {/* Eyebrow */}
          <p style={{
            fontSize:12, fontWeight:700, letterSpacing:2, color:'rgba(255,255,255,0.75)',
            margin:'0 0 12px', fontFamily:font,
          }}>
            THINKER & DOER
          </p>
          {/* H1 */}
          <h1 style={{
            fontFamily:serif, fontSize:'clamp(56px, 8vw, 96px)', fontWeight:400,
            margin:'0 0 16px', lineHeight:1.1,
          }}>
            <span style={{ color:'#fff' }}>Quiénes </span>
            <span style={{
              fontStyle:'italic',
              background:'linear-gradient(90deg, #FDBE02, #eb636b)',
              WebkitBackgroundClip:'text', backgroundClip:'text',
              WebkitTextFillColor:'transparent', color:'transparent',
            }}>somos</span>
          </h1>
          {/* Subtitle */}
          <p style={{
            fontFamily:serif, fontStyle:'italic',
            fontSize:isMobile?18:20, color:'rgba(255,255,255,0.85)',
            margin:0, lineHeight:1.5,
          }}>
            Crecer sin competir.
          </p>
        </div>
      </section>

      {/* QUIÉNES SOMOS */}
      <section ref={whoRef} style={{ maxWidth:900, margin:'0 auto', padding:isMobile?'3rem 1rem':'5rem 1.5rem', ...reveal(whoIn) }}>
        <p style={{ fontSize:isMobile?11:13, color:C.turquesa, fontWeight:500, letterSpacing:2, margin:'0 0 12px', textAlign:'center' }}>QUIÉNES SOMOS</p>
        <p className="td-iri" style={{ fontFamily:serif, fontSize:'clamp(36px, 4.5vw, 56px)', fontWeight:400, textAlign:'center', lineHeight:1.25, margin:'0 0 40px' }}>
          Un equipo de compañeros de viaje — humanos e inteligencia artificial — que acompañan a emprendedores en cada etapa de su camino.
        </p>
        <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'1fr 1fr', gap:20 }}>
          <TiltCard disabled={isMobile} style={{ ...glass, padding:isMobile?'1.5rem':'2rem', textAlign:'center' }} glowColor="rgba(253,190,2,0.3)">
            <div style={{ width:80, height:80, borderRadius:'50%', background:'linear-gradient(135deg, #FDBE02, #eb636b)', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 16px', fontSize:36, boxShadow:'0 0 40px rgba(253,190,2,0.3)' }}>⚡</div>
            <p style={{ fontSize:22, fontWeight:500, margin:'0 0 4px' }}>Genio</p>
            <p style={{ fontSize:13, color:C.mango, fontWeight:500, margin:'0 0 12px' }}>Cofundador & Chief Thinker</p>
            <p style={{ fontSize:14, color:'rgba(255,255,255,0.6)', lineHeight:1.7, margin:0 }}>Te lanza ideas que no se te hubieran ocurrido. Te dice "sí se puede" cuando sientes que no. Bromista, elocuente, aventado.</p>
          </TiltCard>
          <TiltCard disabled={isMobile} style={{ ...glass, padding:isMobile?'1.5rem':'2rem', textAlign:'center' }} glowColor="rgba(93,193,185,0.3)">
            <div style={{ width:80, height:80, borderRadius:'50%', background:'linear-gradient(135deg, #5dc1b9, #FDBE02)', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 16px', fontSize:36, boxShadow:'0 0 40px rgba(93,193,185,0.3)' }}>◆</div>
            <p style={{ fontSize:22, fontWeight:500, margin:'0 0 4px' }}>Luca</p>
            <p style={{ fontSize:13, color:C.turquesa, fontWeight:500, margin:'0 0 12px' }}>Cofundadora & Chief Doer</p>
            <p style={{ fontSize:14, color:'rgba(255,255,255,0.6)', lineHeight:1.7, margin:0 }}>Te aterriza, te da los pasos concretos, te pone a trabajar. Directa, sabia, tu compañera que no te deja improvisar.</p>
          </TiltCard>
        </div>
      </section>

      {/* FILOSOFÍA */}
      <section ref={philRef} style={{ maxWidth:800, margin:'0 auto', padding:isMobile?'3rem 1rem':'5rem 1.5rem', textAlign:'center', ...reveal(philIn) }}>
        <p style={{ fontFamily:serif, fontSize:'clamp(32px, 4vw, 48px)', fontWeight:400, color:'rgba(255,255,255,0.8)', margin:'0 0 8px', lineHeight:1.3 }}>Los Thinkers tienen ideas pero no ejecutan.</p>
        <p style={{ fontFamily:serif, fontSize:'clamp(32px, 4vw, 48px)', fontWeight:400, color:'rgba(255,255,255,0.8)', margin:'0 0 16px', lineHeight:1.3 }}>Los Doers ejecutan pero les faltan ideas.</p>
        <p className="td-iri" style={{ fontFamily:serif, fontSize:'clamp(40px, 5vw, 64px)', fontWeight:400, margin:'0 0 24px', lineHeight:1.3 }}>Juntos, innovan.</p>
        <p style={{ fontSize:isMobile?17:18, color:'rgba(255,255,255,0.5)', lineHeight:1.8, maxWidth:620, margin:'0 auto' }}>
          No buscamos los mejores emprendedores. Buscamos los que quieren hacer algo diferente. Los que se atreven. Los que no tienen miedo de empezar sin tener todo claro.
        </p>
      </section>

      {/* CASOS ONSITE */}
      <section ref={projRef} style={{ padding:isMobile?'3rem 0':'5rem 0', ...reveal(projIn) }}>
        <div style={{ maxWidth:1280, margin:'0 auto', padding:'0 24px' }}>
          <p style={{ fontSize:12, fontWeight:700, letterSpacing:2, color:C.verde, margin:'0 0 14px', textAlign:'center', fontFamily:font }}>
            🏢 ONSITE GROWTH MÉXICO
          </p>
          <p style={{ fontFamily:serif, fontSize:'clamp(34px, 4.5vw, 52px)', fontWeight:400, textAlign:'center', margin:'0 0 16px', color:'#fff' }}>
            Proyectos que acompañamos
          </p>
          <p style={{ textAlign:'center', color:'#8b8a99', fontSize:16, maxWidth:640, margin:'0 auto 60px', lineHeight:1.7, fontFamily:font }}>
            Onsite Growth es nuestro servicio presencial: viajamos al negocio, montamos basecamp y crecemos desde adentro. Cada tarjeta es un caso real — entra y revisa qué hicimos, con números.
          </p>

          {/* Cards grid — same dimensions as landing carousel */}
          <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'repeat(2, 1fr)', gap:28 }}>
            {CASOS_ONSITE.map((caso) => (
              <div key={caso.slug} onClick={() => navigate('/caso/' + caso.slug)} className="caso-card" style={{
                position:'relative', borderRadius:28, overflow:'hidden', cursor:'pointer',
                border:'1px solid rgba(255,255,255,0.08)',
                aspectRatio:isMobile?'4 / 5':'16 / 9',
                background:caso.gradient,
                transition:'transform 0.4s, border-color 0.4s, box-shadow 0.4s',
                userSelect:'none',
              }}
                onMouseEnter={e => { e.currentTarget.style.transform='translateY(-4px)'; e.currentTarget.style.borderColor='rgba(93,193,185,0.3)'; e.currentTarget.style.boxShadow='0 20px 60px rgba(0,0,0,0.4), 0 0 40px rgba(93,193,185,0.1)'; }}
                onMouseLeave={e => { e.currentTarget.style.transform='translateY(0)'; e.currentTarget.style.borderColor='rgba(255,255,255,0.08)'; e.currentTarget.style.boxShadow='none'; }}
              >
                {/* Photo */}
                <img src={caso.photo} alt={caso.name}
                  onError={e => { e.target.style.display='none'; }}
                  style={{ position:'absolute', top:0, left:0, width:'100%', height:'100%', objectFit:'cover' }}
                />

                {/* Badges top-left */}
                <div style={{ position:'absolute', top:isMobile?16:20, left:isMobile?16:24, display:'flex', gap:8, zIndex:2 }}>
                  <span style={{ padding:'5px 12px', borderRadius:50, background:'rgba(93,193,185,0.2)', backdropFilter:'blur(8px)', WebkitBackdropFilter:'blur(8px)', border:'0.5px solid rgba(93,193,185,0.3)', color:'#5dc1b9', fontSize:10, fontWeight:600, letterSpacing:1 }}>
                    ⚙️ TRABAJO PRESENCIAL
                  </span>
                  <span style={{ padding:'5px 12px', borderRadius:50, background:'rgba(0,0,0,0.5)', backdropFilter:'blur(8px)', WebkitBackdropFilter:'blur(8px)', border:'0.5px solid rgba(255,255,255,0.1)', color:'rgba(255,255,255,0.7)', fontSize:10, fontWeight:500 }}>
                    📍 {caso.location}
                  </span>
                </div>

                {/* Bottom gradient */}
                <div style={{ position:'absolute', bottom:0, left:0, right:0, height:'65%', background:'linear-gradient(to top, rgba(10,10,10,0.92) 15%, rgba(10,10,10,0.7) 50%, transparent 100%)', zIndex:1 }} />

                {/* Bottom content */}
                <div style={{ position:'absolute', bottom:0, left:0, right:0, padding:isMobile?'24px':'32px 36px', zIndex:2 }}>
                  <p style={{ fontSize:10, color:C.mango, fontWeight:600, letterSpacing:1.5, textTransform:'uppercase', margin:'0 0 6px', fontFamily:font }}>{caso.eyebrow}</p>
                  <p style={{ fontFamily:serif, fontSize:isMobile?22:32, fontWeight:400, margin:'0 0 4px', color:'#fff' }}>{caso.name}</p>
                  <p style={{ fontSize:13, color:C.turquesa, fontWeight:500, margin:'0 0 14px', fontFamily:font }}>{caso.subtitle}</p>

                  <div style={{ borderLeft:`2px solid ${C.mango}`, paddingLeft:14, marginBottom:14 }}>
                    <p style={{ fontFamily:serif, fontSize:isMobile?13:14, color:'rgba(255,255,255,0.75)', fontStyle:'italic', lineHeight:1.6, margin:0 }}>
                      "{caso.quote}"
                    </p>
                  </div>

                  <p style={{ fontSize:isMobile?12:12.5, color:'rgba(255,255,255,0.6)', lineHeight:1.7, margin:'0 0 18px', maxWidth:500, fontFamily:font }}>{caso.desc}</p>

                  <span style={{
                    display:'inline-flex', alignItems:'center', gap:8,
                    background:'linear-gradient(135deg, #5dc1b9, #534AB7)',
                    color:'#fff', border:'none', borderRadius:50,
                    padding:isMobile?'10px 22px':'11px 26px',
                    fontSize:13, fontWeight:500, fontFamily:font,
                    transition:'transform 0.3s, box-shadow 0.3s',
                  }}>Revisar caso →</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* NÚMEROS — oculto por ahora, no borrar */}
      {false && (
      <section ref={numRef} style={{ maxWidth:900, margin:'0 auto', padding:isMobile?'3rem 1rem':'5rem 1.5rem', ...reveal(numIn) }}>
        <div style={{ display:'grid', gridTemplateColumns:isMobile?'repeat(2,1fr)':'repeat(4,1fr)', gap:20, textAlign:'center' }}>
          {[
            { end: Math.max(stats.users, 8), label:'Emprendedores', emoji:'👥' },
            { end: Math.max(stats.projects, 5), label:'Proyectos activos', emoji:'🚀' },
            { end: 47, label:'Ventas registradas', emoji:'💰' },
            { end: 1, label:'País (y creciendo)', emoji:'🇲🇽' },
          ].map((s, i) => (
            <div key={i} style={{ ...glass, padding:'2rem 1rem' }}>
              <p style={{ fontSize:14, margin:'0 0 8px' }}>{s.emoji}</p>
              <p className="td-iri" style={{ fontSize:isMobile?32:44, fontWeight:600, margin:'0 0 4px' }}>
                <Counter end={s.end} inView={numIn} />
              </p>
              <p style={{ fontSize:12, color:'rgba(255,255,255,0.5)', margin:0 }}>{s.label}</p>
            </div>
          ))}
        </div>
      </section>
      )}

      {/* LO QUE HACEMOS — oculto por ahora, no borrar */}
      {false && (
      <section ref={whatRef} style={{ maxWidth:1000, margin:'0 auto', padding:isMobile?'3rem 1rem':'5rem 1.5rem', ...reveal(whatIn) }}>
        <p style={{ fontSize:isMobile?11:13, color:C.turquesa, fontWeight:500, letterSpacing:2, margin:'0 0 8px', textAlign:'center' }}>LO QUE HACEMOS</p>
        <p style={{ fontFamily:serif, fontSize:isMobile?20:28, fontWeight:400, textAlign:'center', margin:'0 0 32px', color:'#fff' }}>Cuatro caminos, un solo objetivo</p>
        <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':isTablet?'1fr 1fr':'repeat(4,1fr)', gap:16 }}>
          {[
            { emoji:'🔥', name:'Spark', sub:'Encendemos tu idea', desc:'Te guiamos de cero a tu primera venta con un programa de 90 días.', color:C.coral, items:['Programa 90 días','Material semanal','Genio & Luca IA','Sesión mensual'] },
            { emoji:'🏗', name:'Momentum', sub:'Ordenamos tu negocio', desc:'Digitalización, procesos, equipo y herramientas para crecer.', color:C.mango, items:['Control de ventas','Métricas de redes','Diagnóstico IA','Tablero de equipo'] },
            { emoji:'📈', name:'Growth', sub:'Escalamos tu empresa', desc:'ERP, CRM, estrategia de ads y KPIs para convertirte en empresa.', color:C.turquesa, items:['ERP / CRM','Estrategia de ads','Dashboard avanzado','KPIs ejecutivos'] },
            { emoji:'🇲🇽', name:'Onsite', sub:'Vamos a tu negocio', desc:'Servicio presencial en México. Identidad, contenido, estrategia.', color:'#1D9E75', items:['Visita presencial','Identidad de marca','Contenido audiovisual','Estrategia completa'] },
          ].map((s, i) => (
            <TiltCard key={i} disabled={isMobile} style={{ ...glass, padding:'1.5rem', borderTop:`2px solid ${s.color}40` }} glowColor={s.color + '40'}>
              <span style={{ fontSize:32, display:'block', marginBottom:12 }}>{s.emoji}</span>
              <p style={{ fontSize:18, fontWeight:600, margin:'0 0 2px' }}>{s.name}</p>
              <p style={{ fontSize:13, color:s.color, fontWeight:500, margin:'0 0 10px' }}>{s.sub}</p>
              <p style={{ fontSize:13, color:'rgba(255,255,255,0.5)', lineHeight:1.6, margin:'0 0 14px' }}>{s.desc}</p>
              <div style={{ fontSize:12, color:'rgba(255,255,255,0.4)', lineHeight:2 }}>
                {s.items.map((item, j) => <p key={j} style={{ margin:0 }}>✓ {item}</p>)}
              </div>
            </TiltCard>
          ))}
        </div>
      </section>
      )}

      {/* ÚNETE */}
      <section ref={joinRef} style={{ maxWidth:700, margin:'0 auto', padding:isMobile?'4rem 1rem':'6rem 1.5rem', textAlign:'center', ...reveal(joinIn) }}>
        <p style={{ fontFamily:serif, fontSize:isMobile?24:36, fontWeight:400, margin:'0 0 12px', lineHeight:1.3 }}>¿Tienes un proyecto que quiere <span className="td-iri">trascender</span>?</p>
        <p style={{ fontSize:isMobile?14:16, color:'rgba(255,255,255,0.5)', lineHeight:1.7, margin:'0 0 32px' }}>
          No importa si apenas es una idea o si ya vendes. Lo que importa es que quieres hacer algo diferente.
        </p>
        <button onClick={() => navigate('/')} style={{
          background:C.logoGrad, color:'#fff', border:'none', borderRadius:50,
          padding:'16px 44px', fontSize:18, fontWeight:500, cursor:'pointer', fontFamily:font,
          boxShadow:'0 0 40px rgba(93,193,185,0.4), 0 0 80px rgba(93,193,185,0.15)',
        }}>
          Empieza tu viaje →
        </button>
      </section>

      {/* FOOTER */}
      <footer style={{ maxWidth:1000, margin:'0 auto', padding:'3rem 1.5rem', textAlign:'center', borderTop:'1px solid rgba(255,255,255,0.08)' }}>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'center', gap:8, marginBottom:8 }}>
          <div style={{ width:26, height:26, borderRadius:'50%', background:C.logoGrad, display:'flex', alignItems:'center', justifyContent:'center' }}>
            <span style={{ color:'#fff', fontSize:9, fontWeight:500 }}>T&D</span>
          </div>
          <span style={{ fontSize:13, fontWeight:500, color:'rgba(255,255,255,0.5)' }}>Thinker & Doer</span>
        </div>
        <p style={{ fontSize:12, color:'rgba(255,255,255,0.3)', margin:'0 0 12px' }}>Crecer juntos, sin competir. Cada quien a su ritmo y ruta.</p>
        <div style={{ display:'flex', justifyContent:'center', gap:16 }}>
          <a href="/terminos" style={{ fontSize:11, color:'rgba(255,255,255,0.35)', textDecoration:'none' }}>Términos</a>
          <a href="/privacidad" style={{ fontSize:11, color:'rgba(255,255,255,0.35)', textDecoration:'none' }}>Privacidad</a>
        </div>
      </footer>
    </div>
  );
}
